import React, { useEffect } from "react";
import lanrePhoto from "../../images/lanre1.png";
import "./Home.css";
import Footer from "../../footer/Footer";
import Typewriter from "typewriter-effect";
import { Link } from "react-router-dom";
import { BsTwitter, BsLinkedin, BsGithub } from "react-icons/bs";
import { FiMail } from "react-icons/fi";

const Home = () => {
  // Scroll To top
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);

  return (
    <div id="allcontent">
      <div id="imagetext">
        <div className="image">
          <img id="tewoPhoto" src={lanrePhoto} alt="lanre.jpg" />
        </div>
        <div className="text">
          <h4>Hello World, I am</h4>
          <h1> Lanre Adeolu</h1>

          <div className="typewriter">
            <Typewriter
              options={{
                strings: ["A JavaScript Evangelist", "A Frontend Ninja"],
                autoStart: true,
                loop: true,
              }}
            />
          </div>

          <div id="socials">
            <a
              href="https://twitter.com/lanreadeolu"
              target="_blank"
              rel="noreferrer"
            >
              <BsTwitter />
            </a>
            <a
              href="mailto:ladeolu2016@gmail.com"
              target="_blank"
              rel="noreferrer"
            >
              <FiMail />
            </a>
            <a
              href="http://linkedin.com/in/lanre-onasanya-2a357a112"
              target="_blank"
              rel="noreferrer"
            >
              <BsLinkedin />
            </a>
            <a
              href="https://github.com/lanreonasanya02"
              target="_blank"
              rel="noreferrer"
            >
              <BsGithub />
            </a>
          </div>

          <Link to="/contact" className="button">
            <span>Let's Connect 😊</span>
          </Link>
        </div>
      </div>

      <div className="footer">
        <Footer />
      </div>
    </div>
  );
};

export default Home;
